import cn from "classnames";

import TooltipStyles from "./Tooltip.module.scss";

interface TooltipProps {
    title: string;
    triggerText: string;
    content: string[] | string;
}

interface ContentWrapperProps {
    content: string;
    title: string;
}

/**
 * Generate a content text block.
 */
const contentWrapper = (props: ContentWrapperProps) => {
    const { content, title } = props;
    return (
        <div id={title} className={TooltipStyles.tooltip__content__collapsed} role="tooltip">
            {content}
        </div>
    );
};

interface ListWrapperProps {
    content: string[];
    title: string;
}

/**
 * Generate a content list.
 */
const ListWrapper = (props: ListWrapperProps) => {
    const { content, title } = props;
    const mini = content.length <= 12 ? TooltipStyles.tooltip__mini : "";
    const classNames = cn(TooltipStyles.tooltip__content, mini);
    // map and inject an ID so that when we loop over the content the ID's do not change.
    const itemList = content.map((item: string, index: number) => ({ val: item, key: index.toString() }));
    return (
        <div id={title} className={classNames} role="tooltip">
            {itemList.map((item: { val: string, key: string }) => (
                <span className={TooltipStyles.tooltip__item} key={item.key}>
                    {item.val}
                </span>
            ))}
        </div>
    );
};

/**
 * Generate an accessible tooltip wrapper with trigger and tip to show and hide.
 */
const Tooltip = (props: TooltipProps) => {
    const { title, triggerText = "", content = "" } = props;
    // if there is content we should generate the tooltip
    const tip = Array.isArray(content) ? ListWrapper({ content, title }) : contentWrapper({ content, title });
    return (
        <span className={TooltipStyles.tooltip}>
            <button
                className={TooltipStyles.tooltip__trigger}
                type="button"
                aria-label="ToolTip"
                aria-describedby={title}
            >
                {triggerText}
            </button>
            {content.length ? tip : null}
        </span>
    );
};

export { Tooltip as default, TooltipStyles };
export type { TooltipProps };
